export enum PermissionActionType{
    ACTION_SET_ROUTES = 'ACTION_SET_ROUTES',
    ACTION_SET_ROUTES_BAK = 'ACTION_SET_ROUTES_BAK',
    SET_ACTIVE_ROUTE = 'SET_ACTIVE_ROUTE'
}